import getStore from "src/utils/redux/store";
import { selectResolvedPhysicalAddressShortRegion } from "src/utils/redux/slices/checkoutPhysicalAddress/address-selectors";
import { isValidZipCode } from "src/utils/validate";
import { isCA } from "src/utils/userSegment";
import {
  acceptedNoomClinicalOffer,
  isHRTSurvey,
} from "src/utils/userSegment/features";

export function requiresPhysicalAddress(state = getStore().getState()) {
  return acceptedNoomClinicalOffer(state) || isHRTSurvey();
}

export function hasValidPhysicalAddress(state = getStore().getState()) {
  const resolvedAddress = selectResolvedPhysicalAddressShortRegion(state);
  return (
    isValidZipCode(resolvedAddress?.zipcode) &&
    (!isCA() || !!resolvedAddress.region)
  );
}
